module.exports = __webpack_public_path__ + "media/images/logos/clermont-auvergne-innovation-c2de8e26ddc64cd1b19a3b609fdc0dab.jpg";